var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 px-5 border-t border-bordergray bg-white"},[_c('myc-footer-text',{attrs:{"text":_vm.copyright}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }